module.exports = __webpack_public_path__ + "static/full03-63f66036caf9db281409df9b0b992834.png";